import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import { Typography } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';

import ReactTooltip from "react-tooltip"

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '80px',
    maxHeight: '80px',
    /*
    [theme.breakpoints.up('tablet')]: {
      minHeight:'140px',
      maxHeight:'140px',
    },
    [theme.breakpoints.up('md')]: {
      minHeight:'160px',
      maxHeight:'160px',
    },
    */
  },
  container: {
    textAlign: 'left',
    //borderLeft: '3px solid #165469',
    alignItems: 'flex-start',
    /*
    [theme.breakpoints.up('tablet')]: {
      minHeight:'140px',
      maxHeight:'140px',
    },
    [theme.breakpoints.up('md')]: {
      minHeight:'160px',
      maxHeight:'160px',
    },
    */
  },
  sourceTitle: {
    paddingLeft: '5px',
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    width: '100%!important',
  },
  sourceShortTitle: {
    paddingLeft: '2px',
    width: '100%!important',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  heading: {
    color: '#105269!important',
    fontFamily: 'Flanders Art Sans!important',
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'left',
    paddingLeft: '10px',
    margin: '0',
  },
  buttonContainer:{
    display:'flex',
    flexDirection:'row',
    justifyContent:'flex-start',
    paddingLeft:'5px',
  },
  hoverable: {
    backgroundColor: 'rgba(255,255,255,0)!important',
    '&:hover': {
      cursor: 'pointer',
    },
    
    display:'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50px',
    margin:'10px',
    [theme.breakpoints.down('md')]: {
      minHeight: '40px',
      margin:'10px',
    }
  },
  imageContainer: {
    //position:'absolute',
    //border:'1px solid black',
    //clipPath: 'circle(35px at 50% 50%)',
    display:'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    borderRadius: '20px',
    [theme.breakpoints.up('xs')]: {
      width: '50px',
      height: '50px',
      borderRadius: '10px',
    },
    [theme.breakpoints.up('tablet')]: {
      width: '55px',
      height: '55px',
      borderRadius: '10px',
    },
    [theme.breakpoints.up('md')]: {
      width: '55px',
      height: '55px',
      borderRadius: '10px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '80px',
      height: '80px',
      borderRadius: '20px',
    },
  },
  selectorImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center!important',
    width: '60px',
    height: '60px',
    [theme.breakpoints.up('xs')]: {
      width: '30px',
      height: '30px',
    },
    [theme.breakpoints.up('tablet')]: {
      width: '35px',
      height: '35px',
    },
    [theme.breakpoints.up('md')]: {
      width: '35px',
      height: '35px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '60px',
      height: '60px',
    },
    
  },
  solar: {
    backgroundImage: 'url("/images/vea_selected_energy/solar_white.svg")',
  },
  windOnshore: {
    backgroundImage: 'url("/images/vea_selected_energy/onshoreWind_white.svg")',
  },
  windOffshore: {
    backgroundImage: 'url("/images/vea_selected_energy/offshoreWind_white.svg")',
  },
  toolTip: {
    textAlign: 'left',
    color: '#165469!important',
    backgroundColor: '#aaaaaa',
    fontFamily: 'Flanders Art Sans!important',
  },
});

function energySourceSelector(props) {

  const { classes } = props;
  let textTooltipSolar
  let textTooltipWindOnshore
  let textTooltipWindOffshore
  //let suggestionText

  switch (props.lang) {
    case "de":
      textTooltipSolar = "Solar panels"
      textTooltipWindOnshore = "Wind turbines onshore"
      textTooltipWindOffshore = "Wind turbines offshore"
      //suggestionText= 'Click the buttons to choose the energy source' 
      break
    case "en":
      textTooltipSolar = "Solar panels"
      textTooltipWindOnshore = "Wind turbines onshore"
      textTooltipWindOffshore = "Wind turbines offshore"
      //suggestionText= 'Click the buttons to choose the energy source' 
      break
    case "fr":
      textTooltipSolar = "Panneaux solaires"
      textTooltipWindOnshore = "Turbines éoliennes onshore"
      textTooltipWindOffshore = "Turbines éoliennes offshore"
      //suggestionText= 'Cliquez les boutons on ou off à choisir la source d\'énergie' 
      break
    case "nl":
    default:
      textTooltipSolar = "Zonnepanelen"
      textTooltipWindOnshore = "Windturbines onshore"
      textTooltipWindOffshore = "Windturbines offshore"
      //suggestionText= 'Cliquez les boutons on ou off à choisir la source d\'énergie' 
      break
  }

  const tooltipSolar =
    <ReactTooltip id='solar_tooltip' type='light' place='right' className={classes.toolTip}>
      <p>{textTooltipSolar}</p>
    </ReactTooltip>

  const tooltipWindOnshore =
    <ReactTooltip id='wind_onshore_tooltip' type='light' place='right' className={classes.toolTip}>
      <p>{textTooltipWindOnshore}</p>
    </ReactTooltip>

  const tooltipWindOffshore =
    <ReactTooltip id='wind_offshore_tooltip' type='light' place='left' className={classes.toolTip}>
      <p>{textTooltipWindOffshore}</p>
    </ReactTooltip>



  return (
    <div className={classes.root}>
      <Grid item container className={classes.container}>
        <Grid item container xs={12} md={4}>
          <Grid item className={classes.sourceTitle}>
            <div
              className={'  darkbluegreen'}>
              Kies uw energiebron:
            </div>
            <div
              className={'  darkbluegreen'}>
              klik de knoppen aan en uit
            </div>
          </Grid>
          <Grid item className={classes.sourceShortTitle}>
            <div
              className={'  darkbluegreen'}>
              klik uw energiebron aan en uit
          </div>
          </Grid>
        </Grid> 
        
        <Grid item xs={8} className={classes.buttonContainer}>
          <div className={classes.hoverable}>
            <div className={classes.imageContainer + (props.currentTech.solar ? " bgdarkyellow" : " bgmediumgrey")}>
              <div
                className={classes.selectorImage + " " + classes.solar}
                data-for='solar_tooltip'
                data-tip='solar_tooltip'
                data-energy_source='solar'
                onClick={props.setEnergySource}
              >
              </div>

            </div>
            {tooltipSolar}
          </div>
          <div className={classes.hoverable}>
            <div className={classes.imageContainer + (props.currentTech.wind ? " bgdarkblue" : " bgmediumgrey")}>
              <div
                className={classes.selectorImage + " " + classes.windOnshore}
                data-for='wind_onshore_tooltip'
                data-tip='wind_onshore_tooltip'
                data-energy_source='wind'
                onClick={props.setEnergySource}
              >
              </div>

            </div>
            {tooltipWindOnshore}
          </div>
          <div className={classes.hoverable}>
            <div className={classes.imageContainer + (props.currentTech.windOffshore ? " bgbrightblue" : " bgmediumgrey")}>
              <div
                className={classes.selectorImage + " " + classes.windOffshore}
                data-for='wind_offshore_tooltip'
                data-tip='wind_offshore_tooltip'
                data-energy_source='windOffshore'
                onClick={props.setEnergySource}
              >
              </div>

            </div>
            {tooltipWindOffshore}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

energySourceSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(energySourceSelector);
